import React from "react";
import { RedactedText } from "../RedactedText";
import { PaperPatina } from "../realism/PaperPatina";

export const LeakedExcerpts = ({ lines }) => {
  if (!lines?.length) return null;
  const shown = lines.slice(0, 5); // Archive Dossier Standard: max 5
  // Deterministic seed from the first line so the same excerpt block
  // always shows the same patina but different excerpts age differently.
  const seed = `leaked-${(shown[0] || "").slice(0, 24)}`;
  return (
    <section className="mt-12 border border-[#2D2A26] bg-[#131313] p-8 aged-paper paper-patina-host relative overflow-hidden" data-testid="leaked-excerpts">
      <PaperPatina seed={seed} variant="dark" intensity={0.75} />
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D92D20]">
          // LEAKED EXCERPTS
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#757065]">
          → Hover the black bars to unredact
        </div>
      </div>
      <ul className="space-y-3">
        {shown.map((line, i) => (
          <li key={`leak-${i}-${line.slice(0, 16)}`} className="font-mono text-sm text-[#A39E93] flex gap-3 items-start flex-wrap">
            <span className="text-[#757065] shrink-0">{String(i + 1).padStart(2, "0")}.</span>
            <RedactedText>{line}</RedactedText>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default LeakedExcerpts;
